// GraficoEstadosPlugin.js
import FiltroEntreFechas from "./FiltroEntreFechas.vue";
import FiltroEntreFechasProperties from "./FiltroEntreFechasProperties.vue";

const GraficoEstadosPlugin = {
  install(Vue) {
    Vue.component("FiltroEntreFechas", FiltroEntreFechas);
    Vue.component("FiltroEntreFechasProperties", FiltroEntreFechasProperties);
  },
};

export default GraficoEstadosPlugin;
